import { useEffect, useState } from "react";
import { useApi, fmtDateTime } from "@/lib/api";
import { PageHeader, Empty } from "@/components/portal/StatusBadge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Activity() {
  const api = useApi();
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => {
    api("get", "/activity").then(setRows);
  }, [api]);
  const shown = (rows || []).filter((r) => !q || `${r.actor} ${r.verb} ${r.entity} ${r.role}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="activity-page">
      <PageHeader eyebrow="Security" title="Activity log" />
      <p className="mb-4 max-w-2xl text-sm text-[#5C5850]">Every change made in the portal — who did it and when. Public forms are protected with spam filters and submission limits.</p>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter by person or action…" data-testid="activity-filter"
        className="mb-4 h-10 w-full max-w-sm rounded-md border border-[#DDE2EA] bg-white px-3 text-sm outline-none focus:border-[#0E1F3F]" />
      {rows && !shown.length ? <Empty text="No activity yet." /> : (
        <div className="overflow-x-auto rounded-2xl border border-[#E6E2DA] bg-white">
          <Table data-testid="activity-table">
            <TableHeader><TableRow><TableHead>When</TableHead><TableHead>Who</TableHead><TableHead>Action</TableHead><TableHead>Path</TableHead></TableRow></TableHeader>
            <TableBody>
              {shown.map((r) => (
                <TableRow key={r.id} data-testid={`activity-row-${r.id}`}>
                  <TableCell className="whitespace-nowrap">{fmtDateTime(r.created_at)}</TableCell>
                  <TableCell><span className="font-medium">{r.actor}</span> <span className="text-xs capitalize text-[#8C877D]">{r.role}</span></TableCell>
                  <TableCell className="capitalize">{r.verb} {r.entity}</TableCell>
                  <TableCell className="font-mono-num text-xs text-[#8C877D]">{r.method} {r.path}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
